<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-lg-3 vcenter">
      <h3>Manage Users</h3>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10 col-xs-11">
    <div>
      <span class="inactive-user" style="width:75px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;= Inactive User
    </div>

    <aims-common-table
      id="user-table"
      [header]="header"
      [dataSource]="hnUsers | async"
      [permissions]="tablePermissions"
      [addRowInitialObject]="addRowInitialObject"
      (rowUpdated)="handleRowUpdate($event)"
      (rowAdded)="handleRowAdd($event)"
      (rowDeleted)="handleRowDelete($event)"
      [rowClass]="colorRows"
      [pageSize]="10"
      [stickyHeader]="true">
    </aims-common-table>
  </div>
</div>
